module.exports = __webpack_public_path__ + "media/assets/services_manager/banners/MB_MAX-75cd99074e849abb9f38851622dceea84430afce5f65fc8e4eaa62e0e1a33ed0.png";